import { render, staticRenderFns } from "./route-btn.vue?vue&type=template&id=64af44e1&"
import script from "./route-btn.vue?vue&type=script&lang=ts&"
export * from "./route-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports